import { createDuck } from '@/utils'
import { getProductDetails, getCredit, getRemindData } from '@/services/api/common'
import { isObject } from '@/utils/utils'
import { showRemindModal } from '@/utils/copperUtils'

// import { getCouponData, awardCoupon } from '@/services/api/common'
// import { isSelectAll, getAllSelectedSubItemId, formatCartList } from '@/utils/cartUtils'
// import { Toast } from 'antd-mobile'
export const duck = createDuck({
  name: 'commonDuck',
  initialState: {
    reminds: {},
    copper: 0,
    /**
     * 过期时间
     */
    expireDate: '',
    /**
     * 即将过期铜板
     */
    expiring: 0,

    /**
     * 永久的铜板数
     */
    permanent: 0,
  },
  actions: {
    fetchCredit() {
      // @ts-ignore
      return async dispatch => {
        const { data, error } = await getCredit()
        if (!error) {
          const { credit, ...ot } = data || {}
          dispatch(
            duck.change({
              copper: credit > 0 ? credit : 0,
              ...ot,
            }),
          )
        }
      }
    },

    fetchProductDetail(id) {
      // @ts-ignore
      return async dispatch => {
        const { data, error } = await getProductDetails(id)
        if (!error) {
          const _d = Array.isArray(data) ? data[0] : {}
          let { shopUrl, shopDetails: detail } = _d
          const shopDetails = detail ? detail : ''
          /** @type Array<string> */
          const r = []
          const reg1 = /<img.*?src=['"]+(.+?)['"]/g
          // @ts-ignore
          shopDetails.replace(reg1, (s1, s2) => {
            r.push(s2)
          })
          dispatch(
            duck.change({
              [id]: {
                ..._d,
                images: shopUrl.split(','),
                detailImages: r,
              },
            }),
          )
        }
      }
    },
    //changeProductBindStatus

    changeProductBindStatus(id, value) {
      // @ts-ignore
      return async dispatch => {
        dispatch(
          duck.change({
            reminds: {
              [id]: {
                bindRemind: value,
              },
            },
          }),
        )
      }
    },
    changeProductRemindStatus(id, value) {
      // @ts-ignore
      return async dispatch => {
        dispatch(
          duck.change({
            reminds: {
              [id]: {
                visible: value,
              },
            },
          }),
        )
      }
    },
    // productPrevCheck(id) {
    //   // @ts-ignore
    //   return async dispatch => {
    //     const { data } = await prevCheck(id)
    //     if (data === 1) {
    //       dispatch(
    //         duck.change({
    //           reminds: {
    //             [id]: {
    //               bindRemind: true,
    //             },
    //           },
    //         }),
    //       )
    //     }
    //   }
    // },
    fetchProductRemind(id) {
      // @ts-ignore
      return async dispatch => {
        const { data } = await getRemindData(id)

        if (isObject(data)) {
          dispatch(
            duck.change({
              reminds: {
                [id]: {
                  visible: showRemindModal(`remind-${id}`),
                  remindData: data,
                },
              },
            }),
          )
        }
      }
    },
  },
})
